import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import LoaderPost from "../../../Reuseable/LoaderPost";
import Notify from "../SuperstarPageGreetings/NotifyGreetings/NotifyGreetingsContent";
import "./SuperstarPageGreetings.css";

const SuperstarPageGreetings = () => {
  const [greeting, setGreeting] = useState({});
  const [loading, setloading] = useState(true);
  const [status, setStatus] = useState(false);

  useEffect(() => {
    getGreetingStatus();
  }, []);

  const getGreetingStatus = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/star/greetings_star_status").then((res) => {
        if (res.data.status === 200) {
          setGreeting(res.data.greeting);
          setStatus(res.data.action);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {status === true ? (
            <Notify greeting={greeting} getGreetingStatus={getGreetingStatus} />
          ) : (
            <div className="">
              <div className="greetingsHeight d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="box-open">
                    <i
                      style={{ color: "#ffc107" }}
                      className="fas fa-box-open"
                    ></i>
                  </div>
                  <div className="text-white">
                    <h3>No Data Here</h3>
                    <p>
                      <big>Create greetings profile for you</big>
                    </p>
                    <p className="text-muted">
                      <small>
                        A default greetings profile will enable the users <br />{" "}
                        to understand and apply for greeting videos
                      </small>
                    </p>
                  </div>
                  <Link to="/superstar/greetings/greetingsForm">
                    <button className="btn btnSave mt-2 w-50">
                      Create New
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SuperstarPageGreetings;
